import {
  GetServerSideProps,
  GetServerSidePropsContext,
  GetServerSidePropsResult,
} from 'next';
import { NextArticlePath, fetchAllSlugs } from 'src/api/article/dataArticle';
import ArticleSection from 'src/components/LandingPage/ArticleSection';
import Footer from 'src/components/Common/Footer';
import Header from 'src/components/LandingPage/Header';
import Helpers from 'src/components/LandingPage/Layout/LandingPageHelpers';
import NavBar from 'src/components/Common/NavBar';
import styled from 'styled-components';

type ListasPageProps = {
  articleSlugs: NextArticlePath[];
  messages: {
    [index: string]: string;
  };
};

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 5rem;
  background-color: var(--white);
`;

const ListasPage = (props: ListasPageProps): JSX.Element => {
  const { articleSlugs } = props;
  const dataArticleSection = Helpers.getDataArticleSection(articleSlugs);

  return (
    <>
      <Header />
      <NavBar />
      <PageContainer>
        <ArticleSection type="listas" data={dataArticleSection} />
      </PageContainer>
      <Footer />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
): Promise<GetServerSidePropsResult<ListasPageProps>> => {
  let data: NextArticlePath[] = await fetchAllSlugs();
  if (!data) {
    data = [];
  }

  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=120, stale-while-revalidate=120'
  );

  return {
    props: {
      articleSlugs: data,
      messages: {
        ...require(`src/messages/landing/${context.locale}.json`),
        ...require(`src/messages/article/${context.locale}.json`),
      },
    },
  };
};

export default ListasPage;
